export default API => ({
  // oss上传获取凭证等图片
  getAliyunConf() {
      return API({ url: '/standard-raas/v1/resource/getUpFloadFileVoucher', method:  'post' })
  },
})
